function $7ee8781d9217a29b$export$653023c4fd90fd41(options) {
    const handle = async (event)=>{
        event.preventDefault();
        options.form.classList.remove('failed');
        options.form.classList.add('sending');
        event.submitter.disabled = true;
        let res;
        try {
            res = await fetch(options.sendTo, {
                method: 'POST',
                body: new FormData(options.form)
            });
        } catch (error) {
            event.submitter.disabled = false;
            options.form.classList.replace('sending', 'failed');
            return;
        }
        if (!res.ok) {
            event.submitter.disabled = false;
            options.form.classList.replace('sending', 'failed');
            return;
        }
        setTimeout(()=>{
            options.form.reset();
            document.location.href = options.redirectTo;
        }, 1000);
    };
    options.form.addEventListener('submit', handle);
}


const $27f9ec1341fa0628$var$UTM = [
    {
        param: "utm_source",
        key: "utmSource"
    },
    {
        param: "utm_medium",
        key: "utmMedium"
    },
    {
        param: "utm_campaign",
        key: "utmCampaign"
    },
    {
        param: "utm_term",
        key: "utmTerm"
    },
    {
        param: "utm_content",
        key: "utmContent"
    }
];
function $27f9ec1341fa0628$export$bf2f09637ac91973(options) {
    const urlParams = new URLSearchParams(window.location.search);
    const urlUtm = {};
    $27f9ec1341fa0628$var$UTM.map((item)=>[
            item.param,
            item.key
        ]).forEach(([param, key])=>{
        if (!urlParams.has(param)) return;
        urlUtm[key] = urlParams.get(param);
    });
    const urlHasUtm = Object.keys(urlUtm).length > 0;
    if (urlHasUtm) sessionStorage.setItem("utm", JSON.stringify(urlUtm));
    const utm = JSON.parse(sessionStorage.getItem("utm"));
    console.debug("utm", utm);
    if (!utm) return;
    document.addEventListener("DOMContentLoaded", ()=>{
        $27f9ec1341fa0628$var$UTM.map((item)=>item.key).forEach((key)=>{
            if (!(key in utm)) return;
            const field = document.createElement("input");
            field.type = "hidden";
            field.name = key;
            field.value = utm[key];
            options.form.prepend(field);
        });
    });
}


document.addEventListener("DOMContentLoaded", (e)=>{
    document.querySelectorAll("a[href^=\"#\"]").forEach((anchor)=>{
        anchor.addEventListener("click", (e)=>{
            e.preventDefault();
            document.querySelector(e.target.getAttribute("href")).scrollIntoView({
                behavior: "smooth"
            });
        });
    });
});
(0, $27f9ec1341fa0628$export$bf2f09637ac91973)({
    form: document.querySelector('#orcamento > form')
});
(0, $7ee8781d9217a29b$export$653023c4fd90fd41)({
    form: document.querySelector('#orcamento > form'),
    sendTo: 'https://crm.desbrave.com.br/api/v1/accounts/n10/leads',
    redirectTo: '/sucesso.html'
});


//# sourceMappingURL=repo.7b95abc1.js.map
